/* eslint-disable no-unused-vars */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types'
import _ from 'lodash'
import {  reduxForm, propTypes,formValueSelector } from 'redux-form';
import moment from 'moment'
import {
    forms,
    warning
} from '../../../../utils/constants'
import  './style.css'
import  { container } from './style'


function mapStateToProps(state,ownProps) {
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const startdate = selector(state,'startdate')
    const enddate = selector(state,'enddate')
    const eventname = selector(state,'eventname')
    return {
        startdate,
        enddate,
        eventname
    };
}

const FormName = forms.eventinfo
class SetupComplete extends Component {
    render() {
        const { startdate, enddate, eventname } = this.props;
        return (
            <div>
            <div sm={12} style={container}>					
                <h5><span style={{ color:'green' }}>{_.startCase(_.toLower(eventname))} Tournament ( {moment(startdate).format('LL')} through {moment(enddate).format('LL')} )  </span></h5>
                <p>Thank you for completing your tournament setup.  </p>
         
                <p>      
                    Please, submit results <span style={{ color: warning, fontWeight: 'bold' }}>within 15 days</span> after tournament completion.
                </p>              
            </div>
        </div>           
        );
    }
}
SetupComplete.propTypes = {


	startdate:PropTypes.string,
	enddate:PropTypes.string,
	eventname:PropTypes.string,

}
export default reduxForm({
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,null)(SetupComplete))


// WEBPACK FOOTER //
// ./src/containers/event/components/setupComplete/index.js